import * as React from 'react';

function SvgFeedback(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.267 4C5.015 4 4 5.102 4 6.462v8.615c0 1.076.635 1.99 1.521 2.325-.262.84-.796 1.622-1.521 2.598 2.592-.544 3.864-1.115 5.34-2.462h9.393c1.252 0 2.267-1.102 2.267-2.461V6.462C21 5.019 20.077 4 18.733 4H6.267z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.555 7.395c0-.37-.48-.536-.723-.25l-1.886 2.231a.794.794 0 00-.059.04l-.796.424c-.091.078-.091.39-.091.633v1.808c0 .314.192.598.49.723l.78.33a.838.838 0 00.326.066h2.787c.331 0 .63-.194.755-.49l.801-1.894a.768.768 0 00.061-.3v-.67a.802.802 0 00-.813-.789l-2.212-.005.543-1.153a.384.384 0 00.037-.164v-.54zm-8.11 6.677c0 .37.48.536.723.25l1.886-2.231a.78.78 0 00.059-.04l.796-.424c.091-.078.091-.39.091-.633V9.185a.788.788 0 00-.49-.723l-.78-.33a.839.839 0 00-.326-.065H7.617a.816.816 0 00-.755.49l-.801 1.894A.767.767 0 006 10.75v.67c0 .436.364.789.813.79l2.212.004-.543 1.154a.384.384 0 00-.037.163v.54z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgFeedback;
